import React, { Component } from "react";
 
class Home extends Component {
  render() {
    return (
      <div>
        <h2>HELLO</h2>
        <p>This site is under construction.</p>
 
        <p>Please come back soon.</p>
      </div>
    );
  }
}
 
export default Home;


// WEBPACK FOOTER //
// ./src/Home.js